var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachFile = function SvgAttachFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.458 9.38-5.533 5.532a1.644 1.644 0 0 0 0 2.324v0a1.644 1.644 0 0 0 2.324 0l8.63-8.63a3.286 3.286 0 0 0 0-4.647v0a3.286 3.286 0 0 0-4.647 0l-8.63 8.63a4.928 4.928 0 0 0 0 6.971v0a4.93 4.93 0 0 0 6.971 0l6.303-6.302"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachFile);
export default ForwardRef;